// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    height: 80px; 
    background-color: #ffffff; 
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    padding: 10px 20px; 
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center; 
    width: 100%;
    position: fixed;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between; 
    max-width: 1200px; 
    width: 100%;
}

.header-logo {
    width: 150px; 
    height: 100px; 
    margin-right: 30px;
    object-fit: contain; 
}

.header-nav {
    flex: 1 1;
    text-align: center;
}

.header-nav ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    padding-right: 150px;
}

.header-nav li {
    margin: 0 10px;
}

.header-nav li a {
    color: #333; 
    text-decoration: none;
    font-size: 18px;
}

.header-nav li a:hover {
    color: #ffcc00; 
}

.header-controls {
    display: flex;
    align-items: center;
    margin-left: auto; 
}

.cloudclou-text {
    font-family: 'Bezier Sans Bold', sans-serif;
    font-size: 36px; /* Adjust size as needed */
    font-weight: bold;
    color: #333;
    padding-left: 100px;
    padding-right: 155px;
}

.header-contact-button {
    font-family: 'Bezier Sans';
    padding: 10px 20px;
    background-color: #0080ff;
    color: #ffffff;
    border: none;
    font-size: 16px;
    cursor: pointer;
    margin-left: 10px;
    border-radius: 20px;
    text-decoration: none; /* Ensure no underline */
    transition: background-color 0.3s ease, transform 0.1s ease; /* Add smooth transition */
}
.header-contact-button:hover {
    background-color: #0014ff;
    text-decoration: none; /* Ensure no underline on hover */
}

.header-contact-button:active {
    transform: scale(0.98); /* Slightly scale down on click, instead of changing margins */
}

@media (max-width: 768px) {
    .header-content {
        justify-content: space-between;
    }

    .header-nav {
        display: none;
        width: 100%;
    }

    .header-controls {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .cloudclou-text {
        display: none;
    }

    .header-controls-mobile {
        justify-content: center;
        width: 100%;
    }

    /* Reduced button size for mobile */
    .header-contact-button {
        padding: 8px 16px;  /* Reduce padding */
        font-size: 14px;    /* Reduce font size */
        border-radius: 15px; /* Adjust border-radius if needed */
    }

    .header-contact-button:active {
        transform: scale(0.98); /* Same behavior in mobile */
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,eAAe,EAAE,0BAA0B;IAC3C,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB,EAAE,wBAAwB;IAC/C,2DAA2D,EAAE,0BAA0B;AAC3F;AACA;IACI,yBAAyB;IACzB,qBAAqB,EAAE,iCAAiC;AAC5D;;AAEA;IACI,sBAAsB,EAAE,8DAA8D;AAC1F;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,WAAW;IACf;;IAEA,mCAAmC;IACnC;QACI,iBAAiB,GAAG,mBAAmB;QACvC,eAAe,KAAK,qBAAqB;QACzC,mBAAmB,EAAE,mCAAmC;IAC5D;;IAEA;QACI,sBAAsB,EAAE,4BAA4B;IACxD;AACJ","sourcesContent":[".header {\r\n    height: 80px; \r\n    background-color: #ffffff; \r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \r\n    padding: 10px 20px; \r\n    z-index: 1000;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    width: 100%;\r\n    position: fixed;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between; \r\n    max-width: 1200px; \r\n    width: 100%;\r\n}\r\n\r\n.header-logo {\r\n    width: 150px; \r\n    height: 100px; \r\n    margin-right: 30px;\r\n    object-fit: contain; \r\n}\r\n\r\n.header-nav {\r\n    flex: 1;\r\n    text-align: center;\r\n}\r\n\r\n.header-nav ul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-right: 150px;\r\n}\r\n\r\n.header-nav li {\r\n    margin: 0 10px;\r\n}\r\n\r\n.header-nav li a {\r\n    color: #333; \r\n    text-decoration: none;\r\n    font-size: 18px;\r\n}\r\n\r\n.header-nav li a:hover {\r\n    color: #ffcc00; \r\n}\r\n\r\n.header-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-left: auto; \r\n}\r\n\r\n.cloudclou-text {\r\n    font-family: 'Bezier Sans Bold', sans-serif;\r\n    font-size: 36px; /* Adjust size as needed */\r\n    font-weight: bold;\r\n    color: #333;\r\n    padding-left: 100px;\r\n    padding-right: 155px;\r\n}\r\n\r\n.header-contact-button {\r\n    font-family: 'Bezier Sans';\r\n    padding: 10px 20px;\r\n    background-color: #0080ff;\r\n    color: #ffffff;\r\n    border: none;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n    border-radius: 20px;\r\n    text-decoration: none; /* Ensure no underline */\r\n    transition: background-color 0.3s ease, transform 0.1s ease; /* Add smooth transition */\r\n}\r\n.header-contact-button:hover {\r\n    background-color: #0014ff;\r\n    text-decoration: none; /* Ensure no underline on hover */\r\n}\r\n\r\n.header-contact-button:active {\r\n    transform: scale(0.98); /* Slightly scale down on click, instead of changing margins */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .header-content {\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .header-nav {\r\n        display: none;\r\n        width: 100%;\r\n    }\r\n\r\n    .header-controls {\r\n        display: flex;\r\n        justify-content: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .cloudclou-text {\r\n        display: none;\r\n    }\r\n\r\n    .header-controls-mobile {\r\n        justify-content: center;\r\n        width: 100%;\r\n    }\r\n\r\n    /* Reduced button size for mobile */\r\n    .header-contact-button {\r\n        padding: 8px 16px;  /* Reduce padding */\r\n        font-size: 14px;    /* Reduce font size */\r\n        border-radius: 15px; /* Adjust border-radius if needed */\r\n    }\r\n\r\n    .header-contact-button:active {\r\n        transform: scale(0.98); /* Same behavior in mobile */\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
